module.exports = __webpack_public_path__ + "static/media/wait.be632680.svg";